export default __webpack_public_path__ + "static/media/smarthome.d025a922.jpg";